<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <slot></slot>
    </div>
    <!-- 如果需要分页器 -->
    <div class="swiper-pagination"></div>

    <!-- 如果需要导航按钮 -->
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>
  
<script>
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
export default {
  name: "SwiperShow",
  data() {
    return {};
  },
  created() {

  },
  mounted() {
    this.$nextTick(() => {
      var mySwiper = new Swiper(".swiper-container", {
        direction: "horizontal",
        loop: true,
        // 两遍显示相邻两张
        slidesPerView: "auto",
        spaceBetween: -200,
        // swiper动态加载
        observer: true,
        observeParents: true,
        effect: "coverflow", //slide的切换效果，默认为"slide"（位移切换），可设置为"fade"（淡入）"cube"（方块）"coverflow"（3d流）"flip"（3d翻转）。
        coverflow: {
          rotate: 16, //slide做3d旋转时Y轴的旋转角度.默认50
          stretch: 30, //每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
          depth: 60, //slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
          modifier: 2,
          slideShadows: true, //开启slide阴影。默认 true。
        },
        // 当前页居中显示
        centeredSlides: true,
        // 第一张和最后一张贴合边缘
        centeredSlidesBounds: true,

        // 如果需要分页器
        pagination: ".swiper-pagination",
        // 如果需要前进后退按钮
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
      });
    })

  },
  methods: {},
};
</script>
  
<style lang="scss" scoped>
.swiper-container {
  // width: 730px;
  width: 1280px;

  .swiper-wrapper {
    .swiper-slide {
      width: 646px;
      height: 452px;
      overflow: hidden;
      background: url(../assets/img/classic/base.jpg);

      img {
        height: 100%;

      }

      .borderImg {
        padding: 0 170px;
        // padding: 0 126px;
        // border: none !important;

      }
    }

    .swiper-slide-active {
      border: 3px solid #2d72ff;

      img {
        margin-top: 0;
        height: 100%;
        position: relative;
        z-index: 99;

      }
    }
  }
}</style>
  